{{>icon 
uuid=cid
prefix=attributes.prefix
classes=attributes.classes
sr_caption=attributes.caption
name=attributes.icon
styles=attributes.styles
layer_icons=(defined attributes.icon-layers)
}}